import React, { useState } from "react";
import { NavLink } from "react-router-dom";
import {
  FaHome,
  FaUsers,
  FaEnvelope,
  FaFileContract,
  FaCog,
  FaChevronDown,
  FaEdit,
  FaFileAlt
} from "react-icons/fa";
import "./stylesheet/style.css";

function Sidebar() {
  const [dropdownOpen, setDropdownOpen] = useState(false);

  return (
    <nav className="horizontal-navbar">
      <div className="navbar-container">
        
        {/* Logo / Console Identity Branding */}
        <div className="navbar-brand">
          <div className="brand-logo">
            <div className="logo-circle">
              <span className="logo-icon">🛠️</span>
            </div>
          </div>
          <div className="brand-info">
            <p className="brand-tagline">Admin Control Center</p>
            <p className="brand-subline">Management Console</p>
          </div>
        </div>

        {/* Central Core Nav Controls Links */}
        <div className="navbar-menu">
          
          {/* Dashboard */}
          <NavLink
            to="/dashboard"
            className={({ isActive }) => `nav-item ${isActive ? "active" : ""}`}
            end
          >
            <FaHome className="nav-icon" />
            <span className="nav-label">Dashboard</span>
          </NavLink>

          {/* Users Management */}
          <NavLink
            to="/users"
            className={({ isActive }) => `nav-item ${isActive ? "active" : ""}`}
          >
            <FaUsers className="nav-icon" />
            <span className="nav-label">Users</span>
          </NavLink>

          {/* Core System Messages */}
          <NavLink
            to="/messages"
            className={({ isActive }) => `nav-item ${isActive ? "active" : ""}`}
          >
            <FaEnvelope className="nav-icon" />
            <span className="nav-label">Messages</span>
          </NavLink>

          {/* Agreements Dropdown Section Layout Container */}
          <div 
            className="nav-dropdown"
            onMouseEnter={() => setDropdownOpen(true)}
            onMouseLeave={() => setDropdownOpen(false)}
          >
            <button
              className={`nav-item nav-dropdown-toggle ${dropdownOpen ? "active" : ""}`}
              onClick={() => setDropdownOpen(!dropdownOpen)}
              type="button"
            >
              <FaFileContract className="nav-icon" />
              <span className="nav-label">Agreements</span>
              <FaChevronDown className="dropdown-icon" />
            </button>

            {/* Dropdown Options Drawer Card */}
            <div className={`dropdown-menu ${dropdownOpen ? "show" : ""}`}>
              <NavLink
                to="/agreement-terms"
                className="dropdown-item"
                onClick={() => setDropdownOpen(false)}
              >
                <FaEdit className="dropdown-icon" />
                <span>Edit Terms</span>
              </NavLink>
              
              <NavLink
                to="/agreement-checklist"
                className="dropdown-item"
                onClick={() => setDropdownOpen(false)}
              >
                <FaEdit className="dropdown-icon" />
                <span>Edit Checklist</span>
              </NavLink>
              
              <NavLink
                to="/agreements"
                className="dropdown-item"
                onClick={() => setDropdownOpen(false)}
              >
                <FaFileAlt className="dropdown-icon" />
                <span>View All Records</span>
              </NavLink>
            </div>
          </div>

          {/* Offer Letters Generation */}
          <NavLink
            to="/offer-letters"
            className={({ isActive }) => `nav-item ${isActive ? "active" : ""}`}
          >
            <FaFileContract className="nav-icon" />
            <span className="nav-label">Offer Letters</span>
          </NavLink>

          {/* Global System Settings */}
          
        </div>

        {/* Right Side Identity Badge Section */}
        <div className="navbar-utility">
          <div className="user-profile-badge">
            <div className="avatar-wrapper">A</div>
            <div className="user-meta">
              <span className="user-name">Akash Maurya</span>
              <span className="user-role">Administrator</span>
            </div>
          </div>
        </div>

      </div>
    </nav>
  );
}

export default Sidebar;